var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter } from '@angular/core';
import { StaticPathPipe } from '../../../shared/pipes/static-path.pipe';
import { CommunicationService } from '../../../services/communication.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { SCREEN_SIZE } from '../../../classes/enums';
var ProfileHeaderComponent = /** @class */ (function (_super) {
    __extends(ProfileHeaderComponent, _super);
    function ProfileHeaderComponent(staticPathPipe, communicationService) {
        var _this = _super.call(this) || this;
        _this.staticPathPipe = staticPathPipe;
        _this.communicationService = communicationService;
        _this.name = '';
        _this.description = '';
        _this.isAgentProfile = false;
        _this.reviewsClicked = new EventEmitter();
        _this.shouldShowInitials = false;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        return _this;
    }
    ProfileHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.communicationService.screenSize.subscribe(function (size) { return _this.screenSize = size; }));
    };
    ProfileHeaderComponent.prototype.imgErrorHandler = function (event) {
        if (this.isAgentProfile) {
            this.shouldShowInitials = true;
        }
        else {
            event.target.src = this.staticPathPipe.transform('/assets/BalloonLarge.svg');
        }
    };
    return ProfileHeaderComponent;
}(HasSubscriptions));
export { ProfileHeaderComponent };
